import { DateTime } from 'luxon';
import { useCompassScopeCreated, useUserIdFromToken } from 'shared/hooks';
export var useIsBeforeCompassOnboardDateAndMine = function () {
    var compassOnboardDate = useCompassScopeCreated();
    var userId = useUserIdFromToken();
    var isBeforeCompassOnboardDateAndMine = function (date, ownerId) {
        return !!compassOnboardDate &&
            ownerId === userId &&
            DateTime.fromFormat(compassOnboardDate, 'MM/dd/yyyy').startOf('day') >
                DateTime.fromJSDate(new Date(date)).startOf('day');
    };
    return isBeforeCompassOnboardDateAndMine;
};
